import cx from 'classnames';
import { ReactNode } from 'react';
import styles from './WithLabel.module.css';

export interface CustomInputProps {
  label?: string;
  children: ReactNode;
  className?: string;
  tooltip?: ReactNode;
  labelPosition?: 'top' | 'left' | 'right';
  hideLabelSpacing?: boolean;
}

const WithLabel = ({
  label,
  children,
  className,
  tooltip,
  labelPosition = 'top',
  hideLabelSpacing = false,
}: CustomInputProps) => {
  return (
    <div
      className={cx(
        styles.customInput,
        className,
        styles[`label-${labelPosition}`],
        hideLabelSpacing && styles.noLabelSpacing,
      )}
    >
      {label && (
        <div className={styles.labelWrapper}>
          <label>{label}</label>
          {tooltip}
        </div>
      )}
      {children}
    </div>
  );
};

export default WithLabel;
